import AccessRestrictedError from './AccessRestrictedError';

export default class ContentAccessRestrictedError extends AccessRestrictedError {}
